export default __webpack_public_path__ + "static/media/seven_content2.926fc5fa.png";